import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
      },
      {
        path: 'bhandar-admin',
        loadChildren: () =>
          import('./bhandar-admin/bhandaradmin.module').then((m) => m.BhandarAdminModule),
      },
      {
        path: 'web-admin',
        loadChildren: () =>
          import('./web-admin/web-admin.module').then(
            (m) => m.WebAdminModule
          ),
      },
      {
        path: 'librarian',
        loadChildren: () =>
          import('./book-entry/book-entry.module').then(
            (m) => m.BookEntryModule
          ),
      },
      {
        path: 'manuscript',
        loadChildren: () =>
          import('./manuscript/manuscript.module').then(
            (m) => m.ManuscriptModule
          ),
      },
      {
        path: 'member-details',
        loadChildren: () =>
          import('./member-details/member-details.module').then(
            (m) => m.MemberDetailsModule
          ),
      },
      {
        path: 'book-transaction',
        loadChildren: () =>
          import('./book-transaction/book-transaction.module').then(
            (m) => m.BookTransactionModule
          ),
      },
      {
        path:'book-store-admin',
        loadChildren: () => import('./book-store-admin/book-store-admin.module').then(
          (m)=>(m.BookStoreAdminModule)
        )
      },
      {
        path:'book-store-inquiry',
        loadChildren: () => import('./book-store-inquiry/book-store-inquiry.module').then(
          (m)=>(m.BookStoreInquiryModule)
        )
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule { }
